export const MapKey = "AIzaSyALnEOuxN-lLs25mQ4cG8IzlMkr7kHY0jc";
// export const MapKey = "AIzaSyA4p0S4zmTDH4lmYd77COsXNjILTuSleJc";
export const MapBoxAccessKey =
    "pk.eyJ1IjoiaHNuY29vbDgiLCJhIjoiY2s5dHRnbGRwMGN5ZTNsbnliNzl0ZDg5MyJ9.P2AEkILzNEgg9ArpzGVPXw";
export const GoogleAddress = "AIzaSyALnEOuxN-lLs25mQ4cG8IzlMkr7kHY0jc";
